export const VB_MODE = {
  PRESENTATION: "presentation",
  VISUALIZATION: "visualization",
  PUBLIC_VISUALIZATION: "public_visualization",
  PUBLIC_MEDIA_SHARE_VISUALIZATION: "public_media_share_visualization",
  PUBLIC_SINGLE_SHARE_VISUALIZATION: "public_single_share_visualization",
} as const;

export type VB_MODE = (typeof VB_MODE)[keyof typeof VB_MODE];
